
export enum InvoiceAddressCd {
	AS_ENTERED = 'AsEntered',
	BILL_TO_RATES = 'BillToRates',
	PICKUP_DELIVERY_RATES = 'PickupDeliveryRates',
	SAME = 'Same',
	THIRD_PARTY_RATES = 'ThirdPartyRates'}

